import { Component, OnChanges, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { ReportForest } from 'src/app/models/reportForest.model';

@Component({
    selector: 'app-view-ro-signatures',
    templateUrl: './view-ro-signatures.component.html',
    styleUrls: ['./view-ro-signatures.component.scss'],
    standalone: false
})


export class ViewROSignaturesComponent implements OnChanges {

  report = input.required<any>();
  regions: any[] = []

  pageLoaded = false;

  reg = APP_CONSTANTS.URL_REGEX;

  constructor(
    public dialog: MatDialog,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    
  }
  
  ngOnChanges(): void {
    this.findSignatures();
  }

  findSignatures(): void {
    let regions = this.report().forests.map((forest: ReportForest) => forest.region)
    this.regions = [...new Set(regions)]; //remove duplicates
    this.regions = this.regions.map((region: any) => {return {region: region, signature: null}})
    this.report().signatures?.forEach((signature: any) => {
      let region = this.regions.find((region: any) => {
        return (region.region == signature.region && signature.signature_type_id == 1 && signature.signature !="Pending Signature")
      })
      if (region) {
        region.signature = signature
      }
    })
  }
}
